import Helmet from 'react-helmet';
import type { FunctionComponent } from 'react';

import { useLocation } from '../../contexts/RouterContext';
import CallToAction from '../CallToAction';
import Subnav from '../generic/Subnav';
import Text from '../generic/Text';
import SidebarLayout from '../layouts/SidebarLayout';

import { LEGAL_AGENT_ACTIVITY_PATH } from './paths';

/**
 * The Legal Agent portal: header, section subnav, and a left sidebar for scope.
 * Each portal section renders as this route's child.
 */
export const LegalAgentPortal: FunctionComponent = ({ children }) => {
  const { pathname } = useLocation();

  return (
    <>
      <Helmet title="Legal Agent" />
      <CallToAction shouldHideBottomBorder>
        <div className="margin-bottom-lg">
          <Text.H1>Legal Agent</Text.H1>
          <Text.Paragraph>Review the work the Legal Agent has done on your behalf.</Text.Paragraph>
        </div>
      </CallToAction>
      <Subnav activeKey={pathname.split('/').pop()}>
        <Subnav.Item to={LEGAL_AGENT_ACTIVITY_PATH} navKey="activity" testId="legal-agent-subnav-activity">
          Activity
        </Subnav.Item>
      </Subnav>
      <div className="container margin-top">
        <SidebarLayout>
          <SidebarLayout.Sidebar>
            <div data-test-id="legal-agent-sidebar" />
          </SidebarLayout.Sidebar>
          <SidebarLayout.Main>
            {children}
          </SidebarLayout.Main>
        </SidebarLayout>
      </div>
    </>
  );
};
